export const getVideoForDuration = (block, givenVideos, duration) => {
    if (!block) {
        return null;
    }

    const maxDuration = block.block_duration;

    if (maxDuration <= 0 || duration <= 0) {
        return 0;
    }

    const videos = [...givenVideos];
    const maxIndex = videos.length - 1;

    if (duration >= maxDuration) {
        return maxIndex;
    }

    let videoDuration = 0;
    for (const videoIndex in videos) {
        const video = videos[videoIndex]

        videoDuration += Number(video.duration)

        if (duration <= videoDuration) {
            return Number(videoIndex)
        }
    }

    return 0;
}

export default getVideoForDuration
